import React, { memo } from "react";
import { Icon, Tooltip } from "antd";

const IconText = memo(({ type, text, active, tip }) => (
	<Tooltip title={tip}>
		<span className={`icon-text ${active ? "icon-text-active" : ""}`}>
			{type && (
				<Icon
					type={type}
					style={{ marginRight: 8, color: active ? "#26a69a" : "unset" }}
				/>
			)}
			{text || ""}
		</span>
	</Tooltip>
));

export default IconText;
